module.exports = __webpack_public_path__ + "static/media/infoJumbo4.265c26ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/loewer/images/infoJumbo4.png
// module id = 593
// module chunks = 0